import { all } from "redux-saga/effects";
import otpSaga from "./OtpSaga";
import {addVendorSaga, updateVendorSaga, vendorSaga,vendorUserSaga} from "./VendorSaga";
import { addSubVendorSaga, detailSubVendorSaga, subVendorSaga, updateSubVendorSaga } from "./SubVendorSaga";
import{ addComplianceSaga, addOnBoardComplianceSaga, approveComplianceSaga, complianceSaga, configComplianceSaga, onBoardComplianceSaga, updateComplianceSaga } from "./ComplianceSaga";
import { profileSaga, updateProfileSaga } from "./ProfileSaga";
import { addDriverSaga, driverSaga, moreDriverSaga, matrixDriverSaga, ticketDriverSaga, updateDriverSaga } from "./DriverSaga";
import { addFaqSaga, deleteFaqSaga, faqSaga, faqSectionSaga, updateFaqSaga } from "./FAQSaga";
import { addCarSaga, carSaga, deleteCarSaga, facilitiesSaga, updateCarSaga } from "./CarSaga";
import { addTagSaga, ratingSaga, tagSaga, updateTagSaga } from "./TagSaga";
import { userDailyCustomerSaga, userRideAnalyticSaga, userRideDetailsSaga, userTotalRegistrationSaga } from "./DashboardSaga";
import { customerSaga, matrixCustomerSaga, ticketCustomerSaga, updateCustomerSaga } from "./CustomerSaga";
import { addVehicleSaga, deleteVehicleSaga, updateVehicleSaga, vehicleSaga, moreVehicleSaga, matrixVehicleSaga } from "./VehicleSaga";
import registrationSaga from "./RegistrationSaga";
import { userCabRideSaga, userDashboardFeedbackSaga, userOurCarSaga, userRideAcceptSaga, userTopDriverSaga, userTopSubVendorSaga, userTopVendorSaga } from "./TopSectionSaga";
import { assignDriverSaga, cancelTripSaga, invoiceDownloadSaga, invoiceSaga, sosAlertSaga, tripSaga,getReservationDetailsWatcher } from "./TripSaga";
import { notificationCountSaga, notificationSaga, notificationSeenSaga } from "./NotificationSaga";
import { assignVehicleSaga, listAssignedVehicleSaga, requestVehicleSaga, updateAssignDriverSaga, updateAssignSubVendorSaga, updateAssignVehicleSaga } from "./AllotSaga";
import { ChooseYourServiceSaga, addChooseYourServiceSaga, updateChooseYourServiceSaga } from "./ChooseYourServiceSaga";
import { addRateCardSaga, baseFuelSaga, rateCardSaga } from "./RateCardSaga";
import { serviceCitySaga, serviceRegionSaga, addServiceRegionSaga,serviceSubVendorRegionSaga, addSubVendorRegionSaga } from "./ServiceCitySage";
import logoutSaga from "./LogoutSaga";
import { bookingSaga } from "./ReportSaga";
import { loginSaga, magicTokenSaga, tokenVerifySaga } from "./LoginSaga";

export default function* rootSaga() {
  yield all([
    loginSaga(),
    otpSaga(),
    vendorSaga(), 
    subVendorSaga(), 
    complianceSaga(), 
    onBoardComplianceSaga(), 
    addVendorSaga(), 
    addSubVendorSaga(), 
    updateVendorSaga(), 
    detailSubVendorSaga(),
    profileSaga(),
    updateProfileSaga(),
    updateSubVendorSaga(),
    driverSaga(),
    updateDriverSaga(),
    addDriverSaga(),
    addOnBoardComplianceSaga(),
    addComplianceSaga(),
    faqSaga(),
    addFaqSaga(),
    updateFaqSaga(),
    deleteFaqSaga(),
    faqSectionSaga(),
    carSaga(),
    addCarSaga(),
    updateCarSaga(),
    deleteCarSaga(),
    facilitiesSaga(),
    tagSaga(),
    addTagSaga(),
    updateTagSaga(),
    ratingSaga(),
    userRideDetailsSaga(),
    userTotalRegistrationSaga(),
    userRideAnalyticSaga(),
    userDailyCustomerSaga(),
    customerSaga(),
    configComplianceSaga(),
    moreDriverSaga(),
    matrixDriverSaga(),
    ticketDriverSaga(),
    vehicleSaga(),
    updateVehicleSaga(),
    addVehicleSaga(),
    deleteVehicleSaga(),
    approveComplianceSaga(),
    registrationSaga(),
    userOurCarSaga(),
    userCabRideSaga(),
    userTopVendorSaga(),
    userTopSubVendorSaga(),
    userTopDriverSaga(),
    userRideAcceptSaga(),
    userDashboardFeedbackSaga(),
    matrixCustomerSaga(),
    ticketCustomerSaga(),
    tripSaga(),
    notificationSaga(),
    notificationCountSaga(),
    notificationSeenSaga(),
    updateComplianceSaga(),
    requestVehicleSaga(),
    listAssignedVehicleSaga(),
    assignVehicleSaga(),
    updateAssignVehicleSaga(),
    ChooseYourServiceSaga(),
    updateAssignDriverSaga(),
    updateAssignSubVendorSaga(),
    addChooseYourServiceSaga(),
    matrixVehicleSaga(),
    moreVehicleSaga(),
    rateCardSaga(),
    addRateCardSaga(),
    serviceCitySaga(),
    serviceRegionSaga(),
    addServiceRegionSaga(),
    serviceSubVendorRegionSaga(),
    addSubVendorRegionSaga(),
    vendorUserSaga(),
    sosAlertSaga(),
    updateCustomerSaga(),
    updateChooseYourServiceSaga(),
    logoutSaga(),
    cancelTripSaga(),
    assignDriverSaga(),
    bookingSaga(),
    baseFuelSaga(),
    invoiceSaga(),
    invoiceDownloadSaga(),
    magicTokenSaga(),
    tokenVerifySaga(),
    getReservationDetailsWatcher(),
  ]);
}
